export enum EFormType {
    SiteSecurity = 1,
    PhysicalSecurity = 2,
}